import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
    RelaySort, RelayLectureList, RelayChannelList, RelaySearchBox,
    RelayTab,
} from '../components/relays'
import { Page, Pay, WKVisible } from '../components'
import '../css/page/RelaysPage.css'
import '../styles/components/WKTab.css'
import * as componentAction from '../actions/component'
import * as relayAction from '../actions/relays'
import config from '../config'


class RelaysPage extends React.Component {
    componentDidMount () {
        document.title = '转载中心'
        this.initShare()
    }
    initShare () {
        this.props.relayShareInit({
            title: '转载中心',
            desc: '转载最热门课程！不用讲课也能让你收入过万！群主一定要看哦！',
            imgUrl: 'https://staticqc.weike.fm/static/img/relay_icon.jpg',
            link: `/specials/relay/lecture?keyword=`,
        })
    }
    componentWillUnmount () {
        this.props.relayInit()
        this.props.componentInitWktab({ selectId: null, list: [] })
    }
    render() {
        const tab = this.props.params.tab
        const keyword = this.props.location.query.keyword
        return (
            <div className="relays-page">
                <Page>
                    <Pay />
                    <RelaySearchBox keyword={keyword} />
                    <RelayTab tab={tab} query={this.props.location.query} />
                    <RelaySort />
                    <WKVisible show={tab === 'lecture'}>
                        <RelayLectureList keyword={keyword} />
                    </WKVisible>
                    <WKVisible show={tab === 'channel'}>
                        <RelayChannelList keyword={keyword} />
                    </WKVisible>
                </Page>
            </div>
        )
    }
}


export default connect(null, dispatch => bindActionCreators({ ...componentAction, ...relayAction }, dispatch))(RelaysPage)



// WEBPACK FOOTER //
// ./src/pages/RelaysPage.js